import axios from "axios";
import { API } from "../../../backend";
import authHeader from "../../auth-header"
const deletenotification = (state) => {
 
  return axios.delete(API + "parties/delete-notification/"+state+"/",{headers: authHeader(),});
};
const DeleteNotificationService = {
    deletenotification,
  };
  export default DeleteNotificationService;